import { Button, Modal } from '@shared/widgets';
import PasswordOkIcon from '@assets/images/password-ok.svg';
import { useChangePasswordStore } from '@lib/store';

interface IChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SuccessChangePasswordModal = (props: IChangePasswordModalProps) => {
  const changePasswordStore = useChangePasswordStore();

  const handleClick = () => {
    props.onClose();
    changePasswordStore.clear();
  };

  return (
    <Modal title='Change Password' isOpen={props.isOpen} onClose={handleClick}>
      <PasswordOkIcon className='mx-auto mb-4' />
      <p className='mb-8 max-md:text-[#4c4c4c80]'>Your password has been successfully changed</p>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={handleClick}>
        Ok
      </Button>
    </Modal>
  );
};
